export default class LocationRequest {
  locationCookie: string
  locationString: string
}
